import type {Components, Theme} from '@mui/material';

declare module '@mui/material/Badge' {
  export interface BadgePropsVariantOverrides {
    light: true;
  }
}

const commonStyles = (theme: Theme) => ({
  ...theme.typography.CaptionSmallRegular,
  borderRadius: theme.shape.borderRadius,
  height: 12,
  padding: theme.spacing(0, 0.25),
  border: '1px solid',
  color: theme.palette.onColorText,
  transform: 'scale(1) translate(-50%, -50%)',
  left: 0,
  zIndex: 0,
});

export const MuiBadge = (theme: Theme): Components['MuiBadge'] => ({
  styleOverrides: {
    standard: commonStyles(theme),
  },
  variants: [
    {
      props: {variant: 'light'},
      style: {
        '.MuiBadge-badge': {
          ...commonStyles(theme),
        },
      },
    },
    {
      props: {variant: 'light', color: 'primary'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.bg3,
          color: theme.palette.text1,
          borderColor: theme.palette.stroke2,
        },
      },
    },
    {
      props: {variant: 'light', color: 'secondary'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.primaryBrandBg4,
          color: theme.palette.text1,
          borderColor: theme.palette.stroke2,
        },
      },
    },
    {
      props: {variant: 'light', color: 'info'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.primaryBrandBg4,
          color: theme.palette.text1,
          borderColor: theme.palette.stroke2,
        },
      },
    },
    {
      props: {variant: 'light', color: 'success'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.approveBg4,
          color: theme.palette.approveText,
          borderColor: theme.palette.stroke2,
        },
      },
    },
    {
      props: {variant: 'light', color: 'error'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.criticalBg3,
          color: theme.palette.criticalText,
          borderColor: theme.palette.stroke2,
        },
      },
    },
    {
      props: {variant: 'light', color: 'warning'},
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.warningBg2,
          color: theme.palette.text2,
          borderColor: theme.palette.stroke2,
        },
      },
    },
  ],
});
